import { render, staticRenderFns } from "./EquipoAsignado.vue?vue&type=template&id=f9bf9440"
import script from "./EquipoAsignado.vue?vue&type=script&lang=js"
export * from "./EquipoAsignado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports